import moment from "moment";

export const getCreatedBy = (data) => data?.email;

export const getUpdatedBy = (data) => data?.email;

export const dateTimeFormat = (data, format = "DD MMM YYYY HH:mm:ss") => {
    if (data) {
        const dateMoment = moment(data).local();
        const formattedDatePart = dateMoment.format(format);
        return formattedDatePart;
    }
    return "";
};

const getUserCreatedBy = (value, row) => {
    return row?.userCreated?.email;
};

const getUserUpdatedBy = (value, row) => {
    return row?.userUpdated?.email;
};
export const getCreatedOnCreatedByUpdatedOnAndUpdatedByColumn = (params) => {
    return [
        {
            field: "createdBy",
            headerName: "Created By",
            renderHeader: () => <strong>Created By</strong>,
            width: 300,
            valueGetter: getUserCreatedBy,
        },
        {
            field: "createdOn",
            headerName: "Created On",
            renderHeader: () => <strong>Created On</strong>,
            width: 180,
            valueGetter: (value, row) => row?.createdOn, // Keep raw date for sorting
            valueFormatter: (value, row) => dateTimeFormat(value), // Format for display
            sortComparator: (v1, v2) => new Date(v1) - new Date(v2), // Ensure correct sorting
        },
        {
            field: "updatedBy",
            headerName: "Updated By",
            renderHeader: () => <strong>Updated By</strong>,
            width: 300,
            valueGetter: getUserUpdatedBy,
        },
        {
            field: "updatedOn",
            headerName: "Updated On",
            renderHeader: () => <strong>Updated On</strong>,
            width: 180,
            valueGetter: (value, row) => row?.updatedOn, // Keep raw date for sorting
            valueFormatter: (value, row) => dateTimeFormat(value), // Format for display
            sortComparator: (v1, v2) => new Date(v1) - new Date(v2), // Ensure correct sorting
        },
    ];
};